import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableFooter
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate} from 'react-router-dom';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { Formik} from 'formik';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    tableContainer: {
        marginTop: theme.spacing(2),
    },
    table: {
        border: '1px solid #ccc',
    },
    tableHead: {
        backgroundColor: theme.palette.background.default,
        borderBottom: '1px solid #ccc',
        borderTop: '1px solid #ccc',
    },
    tableCell: {
        borderBottom: 'none',
    },
    tableHeaderCell: {
        fontWeight: 'bold',
    },
    tableCellRight: {
        textAlign: 'right',
        paddingRight: '40px',
        borderBottom: 'none',
    },
    tableCellLeft: {
        textAlign: 'left',
        borderBottom: 'none',
    },
    tableHeaderCellRight: {
        textAlign: 'right',
        fontWeight: 'bold',
    },
    tableHeaderCellLeft: {
        textAlign: 'left',
        fontWeight: 'bold',
    },
    tableHeaderCellBorderLeft: {
        textAlign: 'left',
        fontWeight: 'bold',
        borderLeft: '1px solid #ccc',
    },
    tableHeaderCellBorderRight: {
        textAlign: 'right',
        fontWeight: 'bold',
        borderRight: '1px solid #ccc',
    },
}));

const screenCode = 'SUPPLYDEBTLISTREPORT';

export default function SupplyDebtListReport(props) {
    const [title, setTitle] = useState("Supply Debt List Report")
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [supplyDebtInput, setSupplyDebtInput] = useState({
        groupID: '0',
        factoryID: '0',
        routeID: '0',
        year: '',
        month: ''
    })
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const navigate = useNavigate();
    const alert = useAlert();
    const [supplyDebtDetails, setSupplyDebtDetails] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: "0",
        factoryName: "0",
        routeName:"0"
    })
    const [csvHeaders, SetCsvHeaders] = useState([])
    const componentRef = useRef();
    
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown());
    }, [supplyDebtInput.groupID]);

    useEffect(() => {
        trackPromise(
            getRoutesByFactoryID()
        )
    }, [supplyDebtInput.factoryID]);

    useEffect(() => {
        setPage(0);
    }, [supplyDebtDetails]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLYDEBTLISTREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setSupplyDebtInput({
            ...supplyDebtInput,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
        
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }
    
    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(supplyDebtInput.groupID);
        setFactories(factory);
        
        
        setSupplyDebtInput({
            ...supplyDebtInput,
            factoryID: '0',  
            routeID: '0'     
        });
        
        
        setRoutes([]);
    }
    

    async function getRoutesByFactoryID() {
        
        if (supplyDebtInput.factoryID !== '0'&& supplyDebtInput.groupID !== '0') {
            const route = await services.getRoutesForDropDown(supplyDebtInput.factoryID);
            setRoutes(route);
        } else {
            
            setRoutes([]);
        }
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(supplyDebtInput.groupID),
            factoryID: parseInt(supplyDebtInput.factoryID),
            routeID: parseInt(supplyDebtInput.routeID),
            applicableMonth: supplyDebtInput.month === '' ? moment(new Date()).format('MM') : supplyDebtInput.month,
            applicableYear: supplyDebtInput.year === "" ? moment(new Date()).format('YYYY') : supplyDebtInput.year
        }

        getSelectedDropdownValuesForReport(model);
        const supplyDebtData = await services.GetSupplyDebtListDetails(model);
        if (supplyDebtData.statusCode == "Success" && supplyDebtData.data != null) {
            setSupplyDebtDetails(supplyDebtData.data);
            createDataForExcel(supplyDebtData.data);
            if (supplyDebtData.data.length == 0) {
                alert.error("No records to display");
            }
        }
        else {
            alert.error("No records to display");
        }
    }

    async function createDataForExcel(array) {
        const selectedRouteName = supplyDebtInput.routeID !== '0' && routes ? 
            routes[supplyDebtInput.routeID] : 'All Routes';
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Route Name': x.routeName,
                    'Registration Number': x.registrationNumber,
                    'Customer Name': x.name,
                    'Last Month Crop (KG)': Number(x.lastMonthCropWeight),
                    'Todate Crop (KG)':Number( x.thisTotal),
                    'Last Month Debt (Rs.)':Number(parseFloat( x.debtAmount).toFixed(2)),
                    'Loan Balance (Rs.)': Number(parseFloat(x.loanTotal).toFixed(2)),
                }
                res.push(vr);
            });
            
            if (array.length > 0) {
                const totalLastMonthCrop = array.reduce((sum, row) => sum + Number(row.lastMonthCropWeight), 0);
                const totalThisTotal = array.reduce((sum, row) => sum + Number(row.thisTotal), 0);
                const totalDebtAmount = Number(parseFloat(array.reduce((sum, row) => sum + Number(row.debtAmount), 0)).toFixed(2));
                const totalLoanTotal = Number(parseFloat(array.reduce((sum, row) => sum + Number(row.loanTotal), 0)).toFixed(2));    
                
                res.push({
                    'Route Name': 'Total',
                    'Registration Number': '',
                    'Customer Name': '',
                    'Last Month Crop (KG)': totalLastMonthCrop,
                    'Todate Crop (KG)': totalThisTotal,
                    'Last Month Debt (Rs.)': totalDebtAmount,
                    'Loan Balance (Rs.)': totalLoanTotal,
                });
            }
            
            res.push('');
            var vr = {
                'Route Name':`Group : ${selectedSearchValues.groupName}` ,
                'Registration Number': `Factory :${selectedSearchValues.factoryName}`,
            }
            res.push(vr);
           
            var vr = {
                'Route Name':`Route: ${selectedRouteName}` ,
                'Registration Number': `Year & Month: ${supplyDebtInput.month} /${supplyDebtInput.year}`,
            }
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(supplyDebtDetails);
        var settings = {
            sheetName: 'Supply Debt List Report',
            fileName: 'Supply Debt List Report ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName,
            writeOptions: {}
        }

        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })

        let dataA = [
            {
                sheet: 'Supply Debt List Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups[searchForm.groupID],
            factoryName: factories[searchForm.factoryID],
            routeName:routes[searchForm.routeID]
        })
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setSupplyDebtInput({
            ...supplyDebtInput,
            [e.target.name]: value
        });
        setSupplyDebtDetails([]);
    }
    
    function handleDateChange(date) {
        let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        var month = date.getUTCMonth() + 1; //months from 1-12
        var year = date.getUTCFullYear();
        var currentmonth = moment().format('MM');
        let monthName = monthNames[month - 1];
        setSupplyDebtInput({
          ...supplyDebtInput,
          monthName: monthName
        });
        setSupplyDebtInput({
          ...supplyDebtInput,
          month: month.toString(),
          year: year.toString()
        });

        if (selectedDate != null) {
          var prevMonth = selectedDate.getUTCMonth() + 1
          var prevyear = selectedDate.getUTCFullYear();

          if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
            setSelectedDate(date)
          }
        } else {
          setSelectedDate(date)
        }
        setSupplyDebtDetails([]);
    }

    const getPageMargins = () => {
        return `@media print {
                @page {
                size: A4 Landscape !important;
                background-color: white !important;
            }
            body {
                transform-origin: top left;
                background-color: white !important;
            }
        }`;
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: supplyDebtInput.groupID,
                            factoryID: supplyDebtInput.factoryID
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required')
                            })
                        }
                        onSubmit={() => trackPromise(GetDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            size='small'
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="routeID">
                                                            Route
                                                        </InputLabel>
                                                        <TextField select
                                                            fullWidth
                                                            name="routeID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.routeID}
                                                            variant="outlined"
                                                            id="routeID"
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Routes--</MenuItem>
                                                            {generateDropDownMenu(routes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={8}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                     <DatePicker
                                                        autoOk
                                                        variant="inline"
                                                        openTo="month"
                                                        views={["year", "month"]}
                                                        label="Year and Month *"
                                                        helperText="Select applicable month"
                                                        value={selectedDate}
                                                        size='small'
                                                        onChange={(date) => handleDateChange(date)}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Grid>

                                                </Grid>
                                                <br />
                                                <Box display="flex" justifyContent="flex-end" p={2}>    
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        size='small'
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>

                                                {supplyDebtDetails.length > 0 && (
    <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} size="small" stickyHeader>
            <TableHead className={classes.tableHead}>
                <TableRow>
                    <TableCell className={classes.tableHeaderCellBorderLeft}>Route Name</TableCell>
                    <TableCell className={classes.tableHeaderCellLeft}>Registration Number</TableCell>
                    <TableCell className={classes.tableHeaderCellLeft}>Customer Name</TableCell>
                    <TableCell className={classes.tableHeaderCellRight}>Month Crop (KG)</TableCell>
                    <TableCell className={classes.tableHeaderCellRight}>Todate Crop (KG)</TableCell>
                    <TableCell className={classes.tableHeaderCellRight}>Month Debt (RS.)</TableCell>
                    <TableCell className={classes.tableHeaderCellBorderRight}>Loan Balance (Rs.)</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {supplyDebtDetails
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                        <TableRow key={index}>
                            <TableCell className={classes.tableCellLeft}>{row.routeName}</TableCell>
                            <TableCell className={classes.tableCellLeft}>{row.registrationNumber}</TableCell>
                            <TableCell className={classes.tableCellLeft}>{row.name}</TableCell>
                            <TableCell className={classes.tableCellRight}>
                                {Number(row.lastMonthCropWeight).toLocaleString()}
                            </TableCell>
                            <TableCell className={classes.tableCellRight}>
                                {Number(row.thisTotal).toLocaleString()}
                            </TableCell>
                            <TableCell className={classes.tableCellRight}>
                                {Number(row.debtAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell className={classes.tableCellRight}>
                                {Number(row.loanTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                        </TableRow>
                    ))}
            </TableBody>
            <TableFooter style={{ position: "sticky", bottom: 0 }}>
                <TableRow style={{ borderTop: '1px solid #ccc' }}>
                    <TableCell colSpan={3} className={classes.tableCellLeft} style={{ fontWeight: "bolder", fontSize:'14px',color:"black",borderTop:'1px solid #ccc' }}>
                        Total
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px',color:"black",borderTop:'1px solid #ccc'  }}>
                        {supplyDebtDetails.reduce((sum, row) => sum + Number(row.lastMonthCropWeight), 0).toLocaleString()}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px',color:"black",borderTop:'1px solid #ccc'  }}>
                        {supplyDebtDetails.reduce((sum, row) => sum + Number(row.thisTotal), 0).toLocaleString()}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px',color:"black",borderTop:'1px solid #ccc'  }}>
                        {supplyDebtDetails.reduce((sum, row) => sum + Number(row.debtAmount), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px',color:"black" ,borderTop:'1px solid #ccc' }}>
                        {supplyDebtDetails.reduce((sum, row) => sum + Number(row.loanTotal), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
        <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={supplyDebtDetails.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
        />
    </TableContainer>
)}
                                            </CardContent>
                                            {supplyDebtDetails.length > 0 && (
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="submit"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={createFile}
                                                        size='small'
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <div>&nbsp;</div>
                                                    <ReactToPrint
                                                        documentTitle={"Supply Debt List Report"}
                                                        trigger={() => <Button
                                                            color="primary"
                                                            id="btnCancel"
                                                            variant="contained"
                                                            style={{ marginRight: '1rem' }}
                                                            className={classes.colorCancel}
                                                            size='small'
                                                        >
                                                            PDF
                                                        </Button>}
                                                        content={() => componentRef.current}
                                                        pageStyle={getPageMargins()}
                                                    />
                                                    <div hidden={true}>
                                                    <CreatePDF 
                                                     ref={componentRef} 
                                                     SupplyDebtInput={{
                                                        ...supplyDebtInput,
                                                     routeName: supplyDebtInput.routeID !== '0' && routes ? routes[supplyDebtInput.routeID] : 'All Routes'
                                                     }} 
                                                     SupplyDebtDetails={supplyDebtDetails}
                                                     SearchData={selectedSearchValues} 
                                                     />
                                                    </div>
                                                </Box>
                                            )}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    )
}